const SocialLinks = () => {
  return (
    <div
      style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        marginBottom: "20px",
        marginTop: "2rem",
      }}
    >
      <div>🇨🇦 Patent Pending · CIPO 3292395.</div>
      <div
        className="social-links"
        style={{
          fontSize: "1.8rem",

          display: "flex",
          gap: "5px",
          justifyContent: "center",
        }}
      >
        <a href="mailto:admin@loonlog.ca">
          <i className="fa-solid fa-envelope"></i>
        </a>
        <a href="https://www.facebook.com/profile.php?id=61581387360529">
          <i class="fa-brands fa-facebook"></i>
        </a>
        <a href="https://www.youtube.com/channel/UCTUDVeHnV_fkYCEpkqxAlGQ">
          <i class="fa-brands fa-youtube"></i>
        </a>
        <a href="https://www.tiktok.com/@loonlog">
          <i class="fa-brands fa-tiktok"></i>
        </a>
        <a href="https://x.com/LoonLogSocial">
          <i class="fa-brands fa-x-twitter"></i>
        </a>
        <a href="https://www.instagram.com/loonlog.social/?hl=en">
          <i class="fa-brands fa-instagram"></i>
        </a>
        <a href="https://www.reddit.com/r/loonlog/">
          <i class="fa-brands fa-reddit"></i>
        </a>
      </div>
    </div>
  );
};
export default SocialLinks;
